(() => {
  if (window.gutchaReady) return;
  window.gutchaReady = true;
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href="#bewertungen"],a[href="#judgeme_product_reviews"]');
    const reviews = link && document.getElementById(link.hash.slice(1));
    if (!link || !reviews || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (reviews.matches('details')) reviews.open = true;
    history.replaceState(history.state, '', location.pathname + location.search);
    reviews.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'start'});
  });
  if (performance.getEntriesByType('navigation')[0]?.type === 'reload' && document.querySelector('.n-hero')) {
    if (location.hash === '#bewertungen') history.replaceState(history.state, '', location.pathname + location.search);
    history.scrollRestoration = 'manual';
    const resetScroll = () => window.scrollTo({top:0,left:0,behavior:'instant'});
    resetScroll();
    window.addEventListener('pageshow', resetScroll, {once:true});
  }


  // Keep quantities together with narrow non-breaking spaces, including AJAX updates.
  function formatQuantitySpacing(text) {
    return text
      .replace(/(\S)[ \t\u00a0\u202f]*×[ \t\u00a0\u202f]*(?=\S)/g, '$1\u202f×\u202f')
      .replace(/(\d)[ \t\u00a0\u202f]*(?=(?:kg|mg|µg|μg|g|ml|cl|dl|l|L|kcal|kJ|mm|cm|km|m|°C)(?![\p{L}\p{N}_]))/gu, '$1\u202f');
  }
  function normalizeQuantityText(node) {
    const parent = node.parentElement;
    if (!parent || !parent.closest('.g-section,.g-header,.g-footer,.g-sticky,.n-announcement') ||
        parent.closest('script,style,textarea,code,pre,[contenteditable],svg')) return;
    const formatted = formatQuantitySpacing(node.data);
    if (formatted !== node.data) node.data = formatted;
  }
  function normalizeQuantities(root) {
    if (root.nodeType === Node.TEXT_NODE) return normalizeQuantityText(root);
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) normalizeQuantityText(walker.currentNode);
  }
  normalizeQuantities(document.body);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'characterData') normalizeQuantityText(record.target);
      else record.addedNodes.forEach(normalizeQuantities);
    }
  }).observe(document.body, {subtree:true, childList:true, characterData:true});

  // Suppress native image previews/dragging without intercepting normal taps or swipes.
  function isImageInteraction(target) {
    if (!(target instanceof Element)) return false;
    if (target.closest('img, picture')) return true;
    const control = target.closest('a, button');
    return Boolean(control?.querySelector('img, picture'));
  }
  for (const type of ['contextmenu', 'dragstart']) {
    document.addEventListener(type, event => {
      if (isImageInteraction(event.target)) event.preventDefault();
    });
  }

  let swapController;
  let stickyObservers = [];
  const root = () => window.Shopify?.routes?.root || '/';
  const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  const errorText = () => document.documentElement.lang.startsWith('de') ? 'Das hat gerade nicht funktioniert. Bitte versuche es erneut.' : 'Something went wrong. Please try again.';
  function message(form, text) { const box = form.querySelector('.g-form-error'); if (box) { box.textContent = text; box.hidden = false; } }

  const flavourCleanups = new Map();
  function initFlavourStacks() {
    flavourCleanups.forEach((cleanup, section) => { if (!section.isConnected) { cleanup(); flavourCleanups.delete(section); } });
    document.querySelectorAll('[data-n-flavours]').forEach(section => {
      if (section.dataset.nReady) return;
      const panels = [...section.querySelectorAll('[data-n-flavour-panel]')];
      const cans = [...section.querySelectorAll('[data-n-can]')];
      const picks = [...section.querySelectorAll('[data-n-flavour-select]')];
      if (!panels.length || cans.length !== panels.length) return;
      section.dataset.nReady = 'true';
      const mobile = matchMedia('(max-width:749px)');
      const reducedMotion = matchMedia('(prefers-reduced-motion:reduce)');
      let active = 0, gesture = null, suppressClickUntil = 0;
      let orbit = [], queuedSelection = null;
      // Match 0gram: 2 s cadence; restart after 5 s of inactivity.
      // Mobile's first resumed step follows one cadence; desktop splashes immediately.
      const AUTOPLAY_MS = 2000, RESUME_MS = 5000;
      const autoEvents = new AbortController();
      const autoOptions = {capture:true, passive:true, signal:autoEvents.signal};
      let autoTimer = null, resumeTimer = null, resumeAt = 0;
      let mobileVisible = false, desktopVisible = false, pointerHeld = false;
      let desktopHovered = false, desktopFocused = false, desktopIndex = -1;
      function stopAuto() {
        clearInterval(autoTimer);
        autoTimer = null;
        panels.forEach(panel => panel.classList.remove('is-auto-splashed'));
      }
      function autoStep() {
        if (mobile.matches) select(active + 1);
        else {
          desktopIndex = (desktopIndex + 1) % panels.length;
          panels.forEach((panel, index) => panel.classList.toggle('is-auto-splashed', index === desktopIndex));
        }
      }
      function scheduleAuto() {
        const visible = mobile.matches ? mobileVisible : desktopVisible;
        if (panels.length < 2 || !visible || document.hidden || pointerHeld ||
            (!mobile.matches && (desktopHovered || desktopFocused)) ||
            window.Shopify?.designMode || section.dataset.nAutoplayEnabled === 'false') {
          stopAuto();
          return;
        }
        if (autoTimer !== null) return;
        clearTimeout(resumeTimer);
        resumeTimer = null;
        if (Date.now() < resumeAt) {
          resumeTimer = setTimeout(scheduleAuto, resumeAt - Date.now());
          return;
        }
        if (!mobile.matches) autoStep();
        autoTimer = setInterval(autoStep, AUTOPLAY_MS);
      }
      function pauseAuto() {
        stopAuto();
        clearTimeout(resumeTimer);
        resumeAt = Date.now() + RESUME_MS;
        resumeTimer = setTimeout(scheduleAuto, RESUME_MS);
      }
      const mobileVisual = section.querySelector('.n-flavour-mobile');
      const desktopVisual = section.querySelector('.n-flavour-grid');
      const autoObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.target === mobileVisual) mobileVisible = entry.isIntersecting;
          if (entry.target === desktopVisual) desktopVisible = entry.isIntersecting;
        });
        scheduleAuto();
      }, {threshold:[0,.3,.4]});
      autoObserver.observe(mobileVisual);
      autoObserver.observe(desktopVisual);
      document.addEventListener('visibilitychange', scheduleAuto);
      section.addEventListener('pointerdown', event => {
        if (!mobile.matches || !event.isPrimary) return;
        pointerHeld = true;
        stopAuto();
        clearTimeout(resumeTimer);
      }, autoOptions);
      ['pointerup','pointercancel'].forEach(type => section.addEventListener(type, () => {
        if (!pointerHeld) return;
        pointerHeld = false;
        pauseAuto();
      }, autoOptions));
      ['click','keydown','wheel'].forEach(type => section.addEventListener(type, () => {
        if (mobile.matches) pauseAuto();
      }, autoOptions));
      panels.forEach(panel => {
        panel.addEventListener('mouseenter', () => {
          if (mobile.matches) return;
          desktopHovered = true;
          stopAuto();
          clearTimeout(resumeTimer);
        }, {signal:autoEvents.signal});
        panel.addEventListener('mouseleave', () => {
          if (mobile.matches) return;
          desktopHovered = false;
          pauseAuto();
        }, {signal:autoEvents.signal});
      });
      section.addEventListener('focusin', () => {
        if (mobile.matches) return;
        desktopFocused = true;
        stopAuto();
        clearTimeout(resumeTimer);
      }, autoOptions);
      section.addEventListener('focusout', event => {
        if (mobile.matches || section.contains(event.relatedTarget)) return;
        desktopFocused = false;
        pauseAuto();
      }, autoOptions);

      function stopOrbit() {
        queuedSelection = null;
        orbit.forEach(animation => animation.cancel());
        orbit = [];
      }
      function rotateCans(previous, next) {
        const direction = panels[next].dataset.nFlavourArt === 'mango' ? -1 : 1;
        const compact = matchMedia('(max-width:359px)').matches;
        const frontPosition = compact ? 41 : 43, backPosition = compact ? 65 : 64;
        const travel = reducedMotion.matches ? 6 : 18;
        const animations = [previous, next].map((index, position) => {
          const isMango = panels[index].dataset.nFlavourArt === 'mango';
          const tiltDirection = isMango ? 1 : -1;
          const front = isMango ? 100 - frontPosition : frontPosition;
          const back = isMango ? backPosition : 100 - backPosition;
          const center = (front + back) / 2, radius = (back - front) / 2;
          const frames = Array.from({length:33}, (_, step) => {
            const progress = step / 32;
            const angle = (position === 0 ? 0 : Math.PI) + direction * Math.PI * progress;
            const depth = Math.cos(angle), sweep = Math.sin(angle);
            return {
              offset:progress,
              left:`${center - radius * depth + travel * sweep}%`,
              top:`${23.5 - 8.5 * depth + 8 * sweep * direction}px`,
              transform:`translateX(-50%) rotate(${tiltDirection * (12 - 2 * depth) + 5 * sweep}deg) scale(${1 + .08 * depth})`,
              opacity:.85 + .15 * depth,
              zIndex:depth >= 0 ? 3 : 2
            };
          });
          return cans[index].animate(frames, {duration:reducedMotion.matches ? 240 : 720, easing:'cubic-bezier(.4,0,.2,1)'});
        });
        orbit = animations;
        Promise.all(animations.map(animation => animation.finished)).then(() => {
          if (orbit !== animations) return;
          orbit = [];
          const queued = queuedSelection;
          queuedSelection = null;
          if (queued) select(...queued);
        }).catch(() => {});
      }
      function select(index, announce = false, direction = index < active ? -1 : 1) {
        const next = (index + panels.length) % panels.length;
        if (orbit.length) { queuedSelection = [next, announce, direction]; return; }
        const previous = active;
        active = next;
        if (mobile.matches && previous !== active && panels.length === 2) rotateCans(previous, active);
        else if (mobile.matches && previous !== active && !reducedMotion.matches) cans[active].animate([{opacity:0,translate:'24px 0'},{opacity:1,translate:'0 0'}],{duration:320,easing:'ease-out'});
        const palette = getComputedStyle(panels[active]);
        ['top','middle','bottom'].forEach((stop,i) => section.style.setProperty('--n-flavour-'+stop,palette.getPropertyValue('--g-palette-'+['start','middle','end'][i]).trim()));
        panels.forEach((panel, i) => {
          panel.classList.toggle('is-active', i === active);
          panel.inert = mobile.matches && i !== active;
          if (mobile.matches && i !== active) panel.setAttribute('aria-hidden', 'true');
          else panel.removeAttribute('aria-hidden');
        });
        cans.forEach((can, i) => { can.classList.toggle('is-active', i === active); can.setAttribute('aria-pressed', String(i === active)); if (panels.length !== 2) can.inert = i !== active; });
        picks.forEach((pick, i) => pick.setAttribute('aria-pressed', String(i === active)));
        section.querySelectorAll('[data-n-decor]').forEach((decor, i) => decor.classList.toggle('is-active', i === active));
        if (announce) section.querySelector('.n-flavour-announcement').textContent = panels[active].querySelector('h3').textContent;
      }
      section.addEventListener('click', event => {
        if (!mobile.matches) return;
        if (Date.now() < suppressClickUntil) { event.preventDefault(); event.stopPropagation(); return; }
        const button = event.target.closest('[data-n-can],[data-n-flavour-select]');
        if (button) select(Number(button.dataset.nCan ?? button.dataset.nFlavourSelect), true);
      }, true);
      section.addEventListener('keydown', event => {
        if (!mobile.matches || !event.target.closest('.n-flavour-mobile')) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); select(active + (event.key === 'ArrowRight' ? 1 : -1), true);
        }
      });
      section.addEventListener('pointerdown', event => {
        if (!mobile.matches || !event.isPrimary || event.button !== 0 || !event.target.closest('.n-flavour-stack,.n-flavour-grid')) return;
        gesture = {x:event.clientX, y:event.clientY, id:event.pointerId, target:event.target};
        event.target.setPointerCapture?.(event.pointerId);
      });
      section.addEventListener('pointerup', event => {
        if (!gesture || gesture.id !== event.pointerId) return;
        const dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.4) {
          suppressClickUntil = Date.now() + 400;
          select(active + (dx < 0 ? 1 : -1), true);
        }
        gesture = null;
      });
      section.addEventListener('pointercancel', () => { gesture = null; });
      const onViewportChange = () => { gesture = null; pointerHeld = false; desktopHovered = false; desktopFocused = false; stopAuto(); stopOrbit(); select(active); scheduleAuto(); };
      const onMotionChange = () => { if (reducedMotion.matches) stopOrbit(); };
      mobile.addEventListener('change', onViewportChange);
      reducedMotion.addEventListener('change', onMotionChange);
      section.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-n-flavour-panel]');
        if (panel) { pauseAuto(); stopOrbit(); select(Number(panel.dataset.nFlavourPanel)); }
      });
      flavourCleanups.set(section, () => {
        stopAuto();
        clearTimeout(resumeTimer);
        autoEvents.abort();
        autoObserver.disconnect();
        document.removeEventListener('visibilitychange', scheduleAuto);
        stopOrbit();
        mobile.removeEventListener('change', onViewportChange);
        reducedMotion.removeEventListener('change', onMotionChange);
      });
      section.classList.add('n-flavours-ready');
      select(0);
    });
  }


  let offerSelection = null;
  function initOfferChoices() {
    document.querySelectorAll('[data-g-offer-preview]').forEach(section => {
      if (section.dataset.offerReady) return;
      section.dataset.offerReady = 'true';
      const packs = [...section.querySelectorAll('[data-g-pack-choice]')];
      const frequencies = [...section.querySelectorAll('[data-g-frequency]')];
      const intervalSelect = section.querySelector('[data-g-interval-select]');
      const intervals = intervalSelect ? [...intervalSelect.options] : [];
      if (!packs.length) return;
      if (!offerSelection) {
        const requestedPack = new URLSearchParams(location.search).get('pack') || '24';
        const requested = packs.find(p => p.value === requestedPack);
        if (requested) packs.forEach(p => p.checked = p === requested);
      }
      if (offerSelection) {
        const pack = packs.find(p => p.value === offerSelection.pack) || packs.find(p => p.value === '12') || packs[0];
        packs.forEach(p => p.checked = p === pack);
        frequencies.forEach(f => f.checked = f.value === offerSelection.frequency);
        intervals.forEach(i => i.selected = i.value === offerSelection.interval);
      }
      if (!packs.some(p => p.checked)) packs[0].checked = true;
      if (intervals.length && !intervals.some(i => i.selected)) intervals[0].selected = true;
      const money = cents => 'CHF ' + (cents / 100).toFixed(2);
      function update() {
        const pack = packs.find(p => p.checked);
        const trialPack = Number(pack.value) === 4;
        const subscriptionChoice = section.querySelector('.g-subscription-choice');
        if (subscriptionChoice) subscriptionChoice.hidden = trialPack;
        const frequencyFieldset = frequencies[0]?.closest('fieldset');
        if (frequencyFieldset) frequencyFieldset.hidden = trialPack;
        frequencies.forEach(option => {
          option.disabled = trialPack && option.value === 'subscription';
          if (trialPack) option.checked = option.value === 'once';
        });
        const frequency = frequencies.find(f => f.checked);
        const interval = intervals.find(i => i.selected);
        const subscribed = frequency?.value === 'subscription';
        const base = Number(pack.dataset.price);
        const price = subscribed ? Math.round(base * (100 - Number(section.dataset.gAboDiscount)) / 100) : base;
        section.querySelector('[data-g-intervals]').hidden = !subscribed;
        if (intervalSelect) intervalSelect.disabled = !subscribed;
        section.querySelector('[data-g-offer-price]').textContent = money(price);
        const original = section.querySelector('[data-g-offer-original]');
        const comparison = Math.max(Number(pack.dataset.compareAt) || 0, base);
        original.hidden = comparison <= price; original.textContent = money(comparison);
        section.querySelector('[data-g-offer-summary]').textContent = pack.dataset.shipping + (subscribed && interval ? ' · Alle ' + interval.value + ' Wochen' : ' · Einmalige Lieferung');
        section.querySelectorAll('.g-stage-caption').forEach(caption => { caption.textContent = pack.value + ' × 330 ml'; });
        const sticky = section.parentElement.querySelector('[data-g-sticky] a') || document.querySelector('[data-g-sticky] a');
        if (sticky) {
          sticky.querySelector('.g-price-current').textContent = money(price);
          const stickyComparison = sticky.querySelector('.g-price-compare');
          stickyComparison.hidden = comparison <= price;
          stickyComparison.textContent = money(comparison);
        }
        offerSelection = {pack:pack.value,frequency:frequency?.value || 'once',interval:interval?.value || '4'};
        const url = new URL(location.href); url.searchParams.set('pack',pack.value);
        history.replaceState({...history.state,gutchaOffer:offerSelection},'',url);
      }
      section.querySelector('.g-offer-choices').addEventListener('change', update);
      section.querySelector('.g-add').addEventListener('click', () => message(section.querySelector('.g-product-form'), 'Dies ist die Relaunch-Vorschau. Bestellungen sind hier noch nicht freigeschaltet.'));
      update();
    });
  }


  function initShopifyOffers() {
    document.querySelectorAll('[data-g-real-offer]').forEach(section => {
      if (section.dataset.offerReady) return;
      const data = JSON.parse(section.querySelector('[data-g-offer-data]').textContent);
      const packs = [...section.querySelectorAll('[data-g-pack-choice]')];
      const frequencies = [...section.querySelectorAll('[data-g-frequency]')];
      const form = section.querySelector('.g-product-form');
      const variantInput = form.elements.id;
      const planInput = form.querySelector('[data-g-selling-plan]');
      const intervalSelect = section.querySelector('[data-g-interval-select]');
      const button = form.querySelector('.g-add');
      const url = new URL(location.href);
      const explicitVariant = url.searchParams.get('variant');
      let preferredPlan = url.searchParams.get('selling_plan') || offerSelection?.plan;
      // An explicit variant (including a previous choice on reload) takes priority.
      const requested = explicitVariant
        ? packs.find(p => p.dataset.variantId === explicitVariant)
        : !offerSelection && packs.find(p => p.value === (url.searchParams.get('pack') || '24'));
      if (requested) packs.forEach(p => p.checked = p === requested);
      if (!explicitVariant && offerSelection) {
        const restored = packs.find(p => p.value === offerSelection.pack && !p.disabled) || packs.find(p => p.value === '12') || packs[0];
        packs.forEach(p => p.checked = p === restored);
        frequencies.forEach(f => f.checked = f.value === offerSelection.frequency);
      }
      if (url.searchParams.has('selling_plan')) frequencies.forEach(f => f.checked = f.value === 'subscription');
      const money = cents => new Intl.NumberFormat('de-CH', {style:'currency',currency:data.currency}).format(cents / 100);
      let previousVariant;
      function update() {
        const pack = packs.find(p => p.checked) || packs[0];
        const variant = data.variants.find(v => String(v.id) === pack.dataset.variantId);
        if (!variant) { button.disabled = true; return; }
        const plans = variant.count === 4 ? [] : variant.plans;
        if (previousVariant !== variant.id) {
          preferredPlan = intervalSelect.value || preferredPlan;
          intervalSelect.replaceChildren(...plans.map(plan => new Option(plan.name, String(plan.id))));
          if (plans.some(p => String(p.id) === preferredPlan)) intervalSelect.value = preferredPlan;
          else {
            const fourWeeks = plans.find(p => /alle 4 Wochen/i.test(p.name));
            if (fourWeeks) intervalSelect.value = String(fourWeeks.id);
          }
          previousVariant = variant.id;
        }
        section.querySelector('[data-g-frequency-fieldset]').hidden = plans.length === 0;
        frequencies.forEach(f => {
          f.disabled = f.value === 'subscription' ? plans.length === 0 : variant.requiresPlan;
          if (!plans.length) f.checked = f.value === 'once';
          else if (variant.requiresPlan) f.checked = f.value === 'subscription';
        });
        const subscribed = frequencies.some(f => f.checked && f.value === 'subscription');
        const allocation = subscribed ? plans.find(p => String(p.id) === intervalSelect.value) : null;
        const price = allocation ? allocation.price : variant.price;
        const comparison = allocation ? Math.max(allocation.compareAt,variant.price) : variant.compareAt;
        variantInput.value = String(variant.id);
        planInput.disabled = !allocation;
        planInput.value = allocation ? String(allocation.id) : '';
        section.querySelector('[data-g-intervals]').hidden = !subscribed;
        intervalSelect.disabled = !subscribed;
        const discount = plans.length && variant.price > 0 ? Math.round((variant.price - plans[0].price) * 100 / variant.price) : 0;
        section.querySelector('[data-g-subscription-label]').textContent = data.strings.subscription + (discount > 0 ? ' & ' + data.strings.saving + ' ' + discount + '%' : '');
        section.querySelector('[data-g-offer-price]').textContent = money(price);
        const original = section.querySelector('[data-g-offer-original]');
        original.hidden = comparison <= price; original.textContent = money(comparison);
        section.querySelector('[data-g-offer-summary]').textContent = data.strings.shipping + ' · ' + (allocation ? allocation.name : data.strings.once);
        section.querySelectorAll('.g-stage-caption').forEach(caption => caption.textContent = variant.count + ' × 330 ml');
        const sticky = section.parentElement.querySelector('[data-g-sticky]');
        if (sticky) {
          sticky.querySelector('.g-price-current').textContent = money(price);
          const compare = sticky.querySelector('.g-price-compare');
          compare.hidden = comparison <= price; compare.textContent = money(comparison);
        }
        button.disabled = !variant.available || (subscribed && !allocation) || (variant.requiresPlan && !allocation);
        button.replaceChildren(document.createTextNode(variant.available ? data.strings.add : data.strings.soldOut));
        const arrow = document.createElement('span'); arrow.setAttribute('aria-hidden','true'); arrow.textContent = '↗'; button.append(arrow);
        offerSelection = {pack:String(variant.count),frequency:subscribed?'subscription':'once',plan:allocation?String(allocation.id):intervalSelect.value,planName:intervalSelect.selectedOptions[0]?.textContent};
        const currentUrl = new URL(location.href);
        currentUrl.searchParams.set('variant',String(variant.id));
        if (allocation) currentUrl.searchParams.set('selling_plan',String(allocation.id)); else currentUrl.searchParams.delete('selling_plan');
        history.replaceState({...history.state,gutchaOffer:offerSelection},'',currentUrl);
        form.querySelectorAll('.g-form-error').forEach(error => error.hidden = true);
      }
      section.querySelector('[data-g-real-choices]').addEventListener('change',update);
      update();
      section.querySelector('[data-g-real-choices]').hidden = false;
      section.querySelector('[data-g-native-variant]').hidden = true;
      section.dataset.offerReady = 'true';
    });
  }

  function initFounders() {
    document.querySelectorAll('[data-n-founders]').forEach(section => {
      if (section.dataset.foundersReady) return;
      const picks = [...section.querySelectorAll('[data-n-founder-pick]')];
      const panels = [...section.querySelectorAll('[data-n-founder-panel]')];
      if (!picks.length || picks.length !== panels.length) return;
      section.dataset.foundersReady = 'true';
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const destination = section.dataset.nFoundersUrl;
      if (!destination) {
        section.querySelector('.n-founder-picks').setAttribute('role','tablist');
        picks.forEach(pick => pick.setAttribute('role','tab'));
        panels.forEach(panel => panel.setAttribute('role','tabpanel'));
      }
      function founderUrl(index) {
        const url = new URL(destination, location.origin);
        url.searchParams.set('founder', picks[index].dataset.nFounderKey);
        return url.href;
      }
      function bindActivation(button, index) {
        button.addEventListener('click', () => select(index));
      }
      let profileAnimation;
      function select(index) {
        if (section.dataset.founderActive === String(index)) return;
        profileAnimation?.cancel();
        section.dataset.founderActive = String(index);
        picks.forEach((pick, i) => {
          if (!destination) pick.setAttribute('aria-selected',String(i === index));
          else pick.setAttribute('aria-pressed',String(i === index));
          pick.tabIndex = destination || i === index ? 0 : -1;
        });
        panels.forEach((panel,i) => { panel.hidden = i !== index; });
        if (destination) {
          const moreLink = section.querySelector('.n-founders-contact a');
          if (moreLink) moreLink.href = founderUrl(index);
        }
        if (!reduced.matches) profileAnimation = panels[index].animate([{opacity:0,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:240,easing:'ease-out'});
      }
      const hoverSelect = index => event => {
        if (event.pointerType === 'mouse' && matchMedia('(any-hover:hover)').matches) select(index);
      };
      section.querySelectorAll('[data-n-founder-hit]').forEach(hit => {
        const index = picks.findIndex(pick => pick.dataset.nFounderPick === hit.dataset.nFounderHit);
        if (index < 0) return;
        bindActivation(hit, index);
        hit.addEventListener('pointerenter', hoverSelect(index));
      });
      picks.forEach((pick,index) => {
        bindActivation(pick, index);
        pick.addEventListener('pointerenter',hoverSelect(index));
        pick.addEventListener('keydown',event => {
          let next;
          if(event.key === 'ArrowRight') next = (index + 1) % picks.length;
          if(event.key === 'ArrowLeft') next = (index - 1 + picks.length) % picks.length;
          if(event.key === 'Home') next = 0;
          if(event.key === 'End') next = picks.length - 1;
          if(next === undefined) return;
          event.preventDefault(); select(next); picks[next].focus();
        });
      });
      section.addEventListener('shopify:block:select',event => {
        const index = panels.findIndex(panel => panel.dataset.nFounderPanel === event.detail?.blockId);
        if(index >= 0) select(index);
      });
      const stage = section.querySelector('.n-founders-stage');
      stage.addEventListener('pointermove',event => {
        if(event.pointerType !== 'mouse' || reduced.matches || !matchMedia('(any-hover:hover)').matches) return;
        const box = stage.getBoundingClientRect();
        stage.style.setProperty('--founder-x',((event.clientX-box.left)/box.width-.5)*10+'px');
      });
      stage.addEventListener('pointerleave',() => stage.style.setProperty('--founder-x','0px'));
      const requestedFounder = new URLSearchParams(location.search).get('founder');
      const requestedIndex = !destination ? picks.findIndex(pick => pick.dataset.nFounderKey === requestedFounder) : -1;
      select(requestedIndex >= 0 ? requestedIndex : 0);
    });
  }

  let headerCleanup;
  function initHeader() {
    headerCleanup?.();
    const header = document.querySelector('.g-header');
    const wrapper = header?.closest('.shopify-section');
    if (!wrapper) return;
    const controller = new AbortController();
    const menu = header.querySelector('.g-mobile-menu');
    const announcement = wrapper.querySelector('.n-announcement');
    let lastY = Math.max(0, window.scrollY), travel = 0, direction = 0, frame = 0;
    wrapper.classList.add('g-scroll-header');
    const show = () => wrapper.classList.remove('g-scroll-header--hidden');
    const measure = () => wrapper.style.setProperty('--g-announcement-height', `${announcement?.offsetHeight || 0}px`);
    const resize = new ResizeObserver(measure);
    resize.observe(wrapper);
    measure();
    wrapper.classList.toggle('g-scroll-header--hidden', lastY > wrapper.offsetHeight);
    function update() {
      frame = 0;
      const y = Math.max(0, Math.min(window.scrollY, document.documentElement.scrollHeight - window.innerHeight));
      const delta = y - lastY;
      lastY = y;
      if (y < 12 || menu?.open || header.querySelector(':focus-visible')) { show(); travel = 0; return; }
      const nextDirection = Math.sign(delta);
      if (!nextDirection) return;
      if (nextDirection !== direction) travel = 0;
      direction = nextDirection;
      travel += delta;
      if (Math.abs(travel) < 8) return;
      wrapper.classList.toggle('g-scroll-header--hidden', direction > 0 && y > wrapper.offsetHeight);
      travel = 0;
    }
    window.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(update); }, {passive:true, signal:controller.signal});
    header.addEventListener('focusin', show, {signal:controller.signal});
    const mobileMenu = matchMedia('(max-width:749px)');
    const summary = menu?.querySelector('summary');
    const inertRegions = new Map();
    function syncMenu() {
      const open = Boolean(menu?.open && mobileMenu.matches);
      document.documentElement.classList.toggle('g-mobile-menu-open', open);
      summary?.setAttribute('aria-expanded', String(open));
      if (open) {
        show();
        document.querySelectorAll('#MainContent, .shopify-section-group-footer-group, .g-footer').forEach(region => {
          if (!inertRegions.has(region)) inertRegions.set(region, region.inert);
          region.inert = true;
        });
      } else {
        inertRegions.forEach((wasInert, region) => { region.inert = wasInert; });
        inertRegions.clear();
      }
    }
    menu?.addEventListener('toggle', syncMenu, {signal:controller.signal});
    mobileMenu.addEventListener('change', () => { if (!mobileMenu.matches && menu) menu.open = false; syncMenu(); }, {signal:controller.signal});
    header.addEventListener('keydown', event => {
      if (!menu?.open || !mobileMenu.matches) return;
      if (event.key === 'Escape') { event.preventDefault(); menu.open = false; syncMenu(); summary?.focus({preventScroll:true}); }
      if (event.key === 'Tab') {
        const focusable = [...header.querySelectorAll('a[href], summary, button')].filter(el => el.getClientRects().length && !el.disabled);
        const first = focusable[0], last = focusable.at(-1);
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }
    }, {signal:controller.signal});
    syncMenu();
    headerCleanup = () => {
      controller.abort(); resize.disconnect(); cancelAnimationFrame(frame);
      document.documentElement.classList.remove('g-mobile-menu-open');
      inertRegions.forEach((wasInert, region) => { region.inert = wasInert; });
    };
  }

  let imageLightbox, lightboxOpener, galleryPointer, lightboxItems = [], lightboxIndex = 0;
  function selectLightboxImage(index) {
    if (!lightboxItems.length) return;
    lightboxIndex = (index + lightboxItems.length) % lightboxItems.length;
    const item = lightboxItems[lightboxIndex];
    const image = imageLightbox.querySelector('.g-image-lightbox-image');
    image.alt = item.alt;
    image.src = item.src;
    imageLightbox.querySelector('.g-image-lightbox-status').textContent = `${lightboxIndex + 1} / ${lightboxItems.length}`;
    const thumbs = imageLightbox.querySelectorAll('.g-image-lightbox-thumb');
    thumbs.forEach((thumb, i) => {
      if (i === lightboxIndex) thumb.setAttribute('aria-current', 'true');
      else thumb.removeAttribute('aria-current');
    });
    thumbs[lightboxIndex]?.scrollIntoView({block:'nearest', inline:'nearest', behavior:'instant'});
  }
  function openImageLightbox(button) {
    if (!button?.isConnected || imageLightbox?.open) return;
    const gallery = button.closest('.g-gallery-track');
    if (!gallery) return;
    const originals = [...gallery.querySelectorAll('.g-gallery-photo:not([data-gallery-clone]) [data-g-lightbox-src]')];
    lightboxItems = originals.map(opener => {
      const source = opener.closest('.g-gallery-photo').querySelector('img');
      return {src:opener.dataset.gLightboxSrc, thumbnail:source.currentSrc || source.src, alt:source.alt};
    });
    if (!lightboxItems.length) return;
    if (!imageLightbox) {
      imageLightbox = document.createElement('dialog');
      imageLightbox.className = 'g-image-lightbox';
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'g-image-lightbox-close';
      close.textContent = '×';
      const stage = document.createElement('div');
      stage.className = 'g-image-lightbox-stage';
      const image = document.createElement('img');
      image.className = 'g-image-lightbox-image';
      const previous = document.createElement('button');
      previous.type = 'button';
      previous.className = 'g-image-lightbox-arrow g-image-lightbox-previous';
      previous.textContent = '‹';
      const next = document.createElement('button');
      next.type = 'button';
      next.className = 'g-image-lightbox-arrow g-image-lightbox-next';
      next.textContent = '›';
      stage.append(image, previous, next);
      const navigation = document.createElement('div');
      navigation.className = 'g-image-lightbox-navigation';
      const thumbnails = document.createElement('div');
      thumbnails.className = 'g-image-lightbox-thumbnails';
      thumbnails.setAttribute('role', 'group');
      const status = document.createElement('div');
      status.className = 'g-image-lightbox-status';
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');
      navigation.append(thumbnails, status);
      imageLightbox.append(stage, navigation, close);
      document.body.append(imageLightbox);
      previous.addEventListener('click', () => selectLightboxImage(lightboxIndex - 1));
      next.addEventListener('click', () => selectLightboxImage(lightboxIndex + 1));
      close.addEventListener('click', () => imageLightbox.close());
      imageLightbox.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key) || event.altKey || event.ctrlKey || event.metaKey) return;
        event.preventDefault();
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? lightboxItems.length - 1 : lightboxIndex + (event.key === 'ArrowRight' ? 1 : -1);
        const thumbnailFocused = event.target.closest('.g-image-lightbox-thumb');
        selectLightboxImage(index);
        if (thumbnailFocused) thumbnails.children[lightboxIndex]?.focus({preventScroll:true});
      });
      imageLightbox.addEventListener('click', event => {
        if (event.target === imageLightbox || event.target === stage || event.target === navigation) imageLightbox.close();
      });
      imageLightbox.addEventListener('close', () => {
        document.documentElement.classList.remove('g-lightbox-open');
        if (lightboxOpener?.isConnected) lightboxOpener.focus({preventScroll:true});
      });
    }
    imageLightbox.setAttribute('aria-label', gallery.dataset.lightboxLabel);
    const close = imageLightbox.querySelector('.g-image-lightbox-close');
    close.setAttribute('aria-label', gallery.dataset.lightboxClose);
    imageLightbox.querySelector('.g-image-lightbox-previous').setAttribute('aria-label', gallery.dataset.lightboxPrevious);
    imageLightbox.querySelector('.g-image-lightbox-next').setAttribute('aria-label', gallery.dataset.lightboxNext);
    imageLightbox.querySelectorAll('.g-image-lightbox-arrow').forEach(arrow => { arrow.hidden = lightboxItems.length < 2; });
    const thumbnails = imageLightbox.querySelector('.g-image-lightbox-thumbnails');
    thumbnails.setAttribute('aria-label', gallery.getAttribute('aria-label'));
    thumbnails.replaceChildren(...lightboxItems.map((item, index) => {
      const thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'g-image-lightbox-thumb';
      thumb.setAttribute('aria-label', gallery.dataset.lightboxLoad.replace('__index__', index + 1));
      const preview = document.createElement('img');
      preview.src = item.thumbnail;
      preview.alt = '';
      preview.width = 64;
      preview.height = 64;
      thumb.append(preview);
      thumb.addEventListener('click', () => selectLightboxImage(index));
      return thumb;
    }));
    lightboxOpener = button;
    imageLightbox.showModal();
    document.documentElement.classList.add('g-lightbox-open');
    const originalIndex = originals.indexOf(button);
    selectLightboxImage(originalIndex >= 0 ? originalIndex : Number(button.closest('.g-gallery-photo').dataset.galleryIndex) || 0);
    close.focus({preventScroll:true});
  }
  document.addEventListener('pointerdown', event => {
    const photo = event.target.closest('.g-gallery-photo');
    galleryPointer = photo ? {photo, x:event.clientX, y:event.clientY, moved:false} : null;
  }, {passive:true});
  const trackGalleryPointer = event => {
    if (galleryPointer && Math.hypot(event.clientX - galleryPointer.x, event.clientY - galleryPointer.y) > 8) galleryPointer.moved = true;
  };
  document.addEventListener('pointermove', trackGalleryPointer, {passive:true});
  document.addEventListener('pointerup', trackGalleryPointer, {passive:true});
  document.addEventListener('pointercancel', () => { galleryPointer = null; }, {passive:true});
  document.addEventListener('click', event => {
    let button = event.target.closest('[data-g-lightbox-src]');
    if (!button && galleryPointer && event.target.matches('.g-gallery-track')) button = galleryPointer.photo.querySelector('[data-g-lightbox-src]');
    if (!button) return;
    event.preventDefault();
    const moved = event.detail !== 0 && galleryPointer?.moved;
    galleryPointer = null;
    if (!moved) openImageLightbox(button);
  });

  const galleryCleanups = new Map();
  function initGalleries() {
    galleryCleanups.forEach((cleanup, track) => { if (!track.isConnected) { cleanup(); galleryCleanups.delete(track); } });
    document.querySelectorAll('.g-gallery-track').forEach(track => {
      if (track.dataset.loopReady) return;
      const originals = [...track.children];
      if (originals.length < 2) return;
      const controller = new AbortController(), signal = controller.signal;
      const count = originals.length, buffer = 3;
      const desktop = matchMedia('(min-width:750px)');
      const columns = [...track.closest('.g-product').querySelectorAll(':scope > .g-gallery, :scope > .g-buybox')];
      let active = 0, touching = false, drag = null, timer, resizeFrame;
      const wrap = index => (index % count + count) % count;
      originals.forEach((slide, index) => {
        slide.dataset.galleryIndex = index;
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-label', `Bild ${index + 1} von ${count}`);
      });
      function clone(index) {
        const copy = originals[index].cloneNode(true);
        copy.dataset.galleryClone = '';
        copy.setAttribute('aria-hidden', 'true');
        copy.inert = true;
        [copy, ...copy.querySelectorAll('[id]')].forEach(el => el.removeAttribute('id'));
        copy.querySelectorAll('img').forEach(img => { img.loading = 'eager'; img.removeAttribute('fetchpriority'); img.draggable = false; });
        return copy;
      }
      const before = document.createDocumentFragment(), after = document.createDocumentFragment();
      for (let i = 0; i < buffer; i++) { before.append(clone(wrap(i - buffer))); after.append(clone(wrap(i))); }
      track.prepend(before); track.append(after);
      const slides = [...track.children];
      track.dataset.loopReady = 'true';
      track.tabIndex = 0;
      track.setAttribute('role', 'region');
      track.setAttribute('aria-roledescription', 'Karussell');
      track.querySelectorAll('img').forEach(img => { img.draggable = false; });
      const centerOf = slide => {
        const box = slide.getBoundingClientRect(), frame = track.getBoundingClientRect();
        return track.scrollLeft + box.left + box.width / 2 - frame.left - track.clientWidth / 2;
      };
      const nearest = () => slides.reduce((best, slide) => Math.abs(centerOf(slide) - track.scrollLeft) < Math.abs(centerOf(best) - track.scrollLeft) ? slide : best, slides[0]);
      function settle() {
        if (desktop.matches || touching || drag) return;
        const current = nearest();
        active = Number(current.dataset.galleryIndex);
        if (current.hasAttribute('data-gallery-clone')) {
          const remainder = track.scrollLeft - centerOf(current);
          track.scrollTo({left:centerOf(originals[active]) + remainder, behavior:'instant'});
        }
      }
      const armSettle = () => { clearTimeout(timer); timer = setTimeout(settle, 180); };
      if ('onscrollend' in window) track.addEventListener('scrollend', settle, {signal});
      else track.addEventListener('scroll', armSettle, {passive:true,signal});
      track.addEventListener('touchstart', () => { touching = true; }, {passive:true,signal});
      ['touchend','touchcancel'].forEach(type => track.addEventListener(type, () => { touching = false; if (!('onscrollend' in window)) armSettle(); }, {passive:true,signal}));
      track.addEventListener('keydown', event => {
        if (desktop.matches || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        settle();
        const current = nearest();
        const target = event.key === 'Home' ? originals[0] : event.key === 'End' ? originals[count - 1] : slides[slides.indexOf(current) + (event.key === 'ArrowRight' ? 1 : -1)];
        if (target) track.scrollTo({left:centerOf(target),behavior:motion()});
      }, {signal});
      track.addEventListener('pointerdown', event => {
        if (desktop.matches || event.pointerType !== 'mouse' || event.button !== 0) return;
        settle();
        drag = {id:event.pointerId,x:event.clientX,left:track.scrollLeft};
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
        event.preventDefault();
      }, {signal});
      track.addEventListener('pointermove', event => {
        if (!drag || drag.id !== event.pointerId) return;
        track.scrollLeft = drag.left + drag.x - event.clientX;
      }, {signal});
      function endDrag(event) {
        if (!drag || drag.id !== event.pointerId) return;
        const target = nearest();
        drag = null;
        track.classList.remove('is-dragging');
        if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
        track.scrollTo({left:centerOf(target),behavior:motion()});
        armSettle();
      }
      ['pointerup','pointercancel','lostpointercapture'].forEach(type => track.addEventListener(type,endDrag,{signal}));
      function updateColumnHeights() {
        columns.forEach(column => column.style.setProperty('--g-column-height', `${column.offsetHeight}px`));
      }
      function syncLayout() {
        clearTimeout(timer);
        drag = null;
        track.classList.remove('is-dragging');
        track.tabIndex = desktop.matches ? -1 : 0;
        if (desktop.matches) track.removeAttribute('aria-roledescription');
        else track.setAttribute('aria-roledescription', 'Karussell');
        track.scrollTo({left:desktop.matches ? 0 : centerOf(originals[active]),behavior:'instant'});
        updateColumnHeights();
      }
      let lastWidth = track.clientWidth;
      const observer = new ResizeObserver(() => {
        updateColumnHeights();
        if (track.clientWidth === lastWidth) return;
        lastWidth = track.clientWidth;
        cancelAnimationFrame(resizeFrame);
        resizeFrame = requestAnimationFrame(syncLayout);
      });
      observer.observe(track);
      columns.forEach(column => observer.observe(column));
      desktop.addEventListener('change', syncLayout, {signal});
      syncLayout();
      galleryCleanups.set(track, () => { controller.abort(); observer.disconnect(); clearTimeout(timer); cancelAnimationFrame(resizeFrame); });
    });
  }


  let titleSizeObserver;
  function initMobileProductTitle() {
    titleSizeObserver?.disconnect();
    const box = document.querySelector('.g-buybox');
    const title = box?.querySelector('h1');
    if (!title) return;
    const fit = () => {
      if (!title.isConnected) return;
      if (innerWidth > 749) { title.style.removeProperty('--g-mobile-title-size'); return; }
      const style = getComputedStyle(title);
      const probe = document.createElement('span');
      Object.assign(probe.style, {position:'absolute', visibility:'hidden', whiteSpace:'nowrap', fontFamily:style.fontFamily, fontWeight:style.fontWeight, fontSize:'100px', letterSpacing:'-.04em'});
      probe.setAttribute('aria-hidden','true');
      document.body.append(probe);
      const names = [...box.querySelectorAll('[data-g-title-candidates] span')].map(node => node.textContent.trim());
      names.push(title.textContent.trim());
      let widest = 1;
      for (const name of names) { probe.textContent = name; widest = Math.max(widest, probe.getBoundingClientRect().width); }
      probe.remove();
      title.style.setProperty('--g-mobile-title-size', Math.min(32, Math.floor((title.clientWidth - 2) / widest * 1000) / 10) + 'px');
    };
    titleSizeObserver = new ResizeObserver(fit);
    titleSizeObserver.observe(box);
    fit();
    document.fonts.ready.then(fit);
  }

  function init() {
    initMobileProductTitle();
    initGalleries();
    initHeader();
    initFounders();
    initOfferChoices();
    initShopifyOffers();
    const finder = document.querySelector('[data-g-finder-script]');
    if (finder && !window.gutchaFinderReady && !document.querySelector('script[data-g-finder-runtime]')) {
      const script = document.createElement('script'); script.src = finder.dataset.gFinderScript; script.dataset.gFinderRuntime = '';
      script.onerror = () => script.remove(); document.head.append(script);
    }
    initFlavourStacks();
    stickyObservers.forEach(observer=>observer.disconnect()); stickyObservers=[];
    document.querySelectorAll('[data-g-sticky]').forEach(bar => {
      bar.hidden = true;
      const form = document.querySelector('.g-product-form'); const footer = document.querySelector('.g-footer');
      if (!form) return;
      let formVisible = true, footerVisible = false;
      const observer = new IntersectionObserver(entries => {
        for (const entry of entries) { if (entry.target === form) formVisible = entry.isIntersecting; if (entry.target === footer) footerVisible = entry.isIntersecting; }
        bar.hidden = formVisible || footerVisible || form.getBoundingClientRect().bottom > 0;
      });
      stickyObservers.push(observer);
      observer.observe(form); if (footer) observer.observe(footer);
    });
  }
  // Animate colour stops themselves: gradients cannot transition as background-image.
  const colourProperties = ['start','middle','end','title','choice'].map(name => '--g-transition-' + name);
  let colourAnimation;
  let animatedColours = false;
  if (window.CSS?.registerProperty) {
    colourProperties.forEach(name => {
      try { CSS.registerProperty({name, syntax:'<color>', inherits:true, initialValue:'#172a21'}); } catch (_) { /* Already registered in the theme editor. */ }
    });
    animatedColours = true;
  }
  function productColours(main) {
    const product = main.querySelector('[data-g-product]');
    const style = getComputedStyle(main);
    if (main.hasAttribute('data-g-flavour-transition')) return Object.fromEntries(colourProperties.map(name => [name, style.getPropertyValue(name).trim()]));
    return Object.fromEntries(colourProperties.map((name, index) => [name, index < 3
      ? style.getPropertyValue('--g-palette-' + ['start','middle','end'][index]).trim()
      : index === 3 ? getComputedStyle(product.querySelector('h1')).color : getComputedStyle(product).getPropertyValue('--g-choice-color').trim()]));
  }
  function animateProductColours(main, previous) {
    colourAnimation?.cancel();
    main.removeAttribute('data-g-flavour-transition');
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (animatedColours) {
      const next = productColours(main);
      main.setAttribute('data-g-flavour-transition','');
      const animation = main.animate([previous,next], {duration:480,easing:'ease-in-out'});
      colourAnimation = animation;
      animation.finished.then(() => {
        if (colourAnimation === animation) { main.removeAttribute('data-g-flavour-transition'); colourAnimation = null; }
      }).catch(() => {});
    }
    main.querySelectorAll('.g-gallery-track > :not([data-gallery-clone]) img,.g-product-description').forEach(node => {
      node.animate([{opacity:0},{opacity:1}], {duration:320,easing:'ease-out'});
    });
  }

  // Reviews, the social feed and the map are shared across flavours. Keep their
  // mounted app instances when a product section's surrounding markup changes.
  function preserveApps(main, next) {
    ['[data-g-all-reviews]','[data-g-social-app]','[data-g-finder]'].forEach(selector => {
      const previous = main.querySelector(selector), replacement = next.querySelector(selector);
      if (previous && replacement) replacement.replaceWith(previous);
    });
  }

  function selectIncomingOffer(next, url, selection) {
    const dataNode = next.querySelector('[data-g-offer-data]');
    if (!selection || !dataNode) return;
    const data = JSON.parse(dataNode.textContent);
    const chosen = data.variants.find(v => String(v.count) === selection.pack && v.available)
      || data.variants.find(v => v.count === 12) || data.variants[0];
    if (!chosen) return;
    next.querySelectorAll('[data-g-pack-choice]').forEach(input => input.checked = input.dataset.variantId === String(chosen.id));
    url.searchParams.set('variant', chosen.id);
    url.searchParams.delete('pack');
    const plan = chosen.count !== 4 && selection.frequency === 'subscription' &&
      (chosen.plans.find(p => String(p.id) === selection.plan) || chosen.plans.find(p => p.name === selection.planName));
    if (plan) url.searchParams.set('selling_plan', plan.id); else url.searchParams.delete('selling_plan');
    next.querySelectorAll('[data-g-frequency]').forEach(input => input.checked = input.value === (plan ? 'subscription' : 'once'));
  }
  const productPages = new Map();
  const sectionMarkup = new Map();
  let prefetchTimer;
  function productPageUrl(href) {
    const url = new URL(href, location.href);
    ['preview_theme_id','view'].forEach(key => {
      const value = new URL(location.href).searchParams.get(key);
      if (value && !url.searchParams.has(key)) url.searchParams.set(key, value);
    });
    ['variant','selling_plan','pack'].forEach(key => url.searchParams.delete(key));
    url.hash = ''; url.searchParams.sort();
    return url;
  }
  function loadProductPage(href) {
    const url = productPageUrl(href), key = url.href;
    const cached = productPages.get(key);
    if (cached && Date.now() - cached.time < 60000) return cached.promise;
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 15000);
    const entry = {time:Date.now()};
    entry.promise = fetch(url, {signal:controller.signal, credentials:'same-origin', headers:{Accept:'text/html'}})
      .then(async response => {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!doc.querySelector('#MainContent [data-g-product]')) throw new Error('Missing product');
        return doc;
      }).catch(error => {
        if (productPages.get(key) === entry) productPages.delete(key);
        throw error;
      }).finally(() => clearTimeout(timer));
    productPages.set(key, entry);
    if (productPages.size > 8) productPages.delete(productPages.keys().next().value);
    return entry.promise;
  }
  function prefetchProductPages() {
    clearTimeout(prefetchTimer);
    if (navigator.connection?.saveData || /(^|-)2g$/.test(navigator.connection?.effectiveType || '')) return;
    prefetchTimer = setTimeout(() => {
      if (document.visibilityState !== 'visible') return;
      [...document.querySelectorAll('.g-flavour-links a:not([aria-current="true"])')].slice(0, 2).forEach(link => {
        if (new URL(link.href).origin !== location.origin) return;
        loadProductPage(link.href).then(doc => {
          doc.querySelectorAll('.g-product-stage img').forEach(source => {
            const image = new Image(); image.decoding = 'async';
            if (source.sizes) image.sizes = source.sizes;
            if (source.srcset) image.srcset = source.srcset;
            image.src = source.src;
          });
        }).catch(() => {});
      });
    }, 300);
  }
  function replaceProductSections(main, next) {
    const current = new Map([...main.children].map(node => [node.id, node]));
    let cursor = main.firstElementChild;
    const retained = new Set();
    [...next.children].forEach(incoming => {
      const old = current.get(incoming.id);
      const markup = incoming.outerHTML;
      let node = incoming;
      if (old && !incoming.querySelector('[data-g-product]') && sectionMarkup.get(incoming.id) === markup) {
        node = old;
      } else if (old) {
        preserveApps(old, incoming);
      }
      sectionMarkup.set(incoming.id, markup);
      retained.add(node);
      if (node === cursor) cursor = cursor.nextElementSibling;
      else if (old === cursor) {
        cursor = cursor.nextElementSibling;
        old.replaceWith(node);
      } else main.insertBefore(node, cursor);
    });
    [...main.children].forEach(node => { if (!retained.has(node)) node.remove(); });
  }
  let renderedProductUrl = location.href;
  let renderedProductState = history.state;
  async function swap(href, {preserveOffer = false, fromHistory = false, focus = false} = {}) {
    const started = performance.now();
    const url = new URL(href, location.href); if (url.origin !== location.origin) return;
    const main = document.getElementById('MainContent');
    if (!main?.querySelector('[data-g-product]')) { location.assign(url); return; }
    const selection = preserveOffer ? {...offerSelection} : null;
    if (preserveOffer) {
      url.searchParams.delete('variant'); url.searchParams.delete('selling_plan');
      if (selection.pack) url.searchParams.set('pack', selection.pack);
    }
    // Retain Shopify's draft preview context without carrying another variant ID.
    const currentUrl = new URL(location.href);
    ['preview_theme_id','view'].forEach(key => { if (!url.searchParams.has(key) && currentUrl.searchParams.has(key)) url.searchParams.set(key,currentUrl.searchParams.get(key)); });
    swapController?.abort(); swapController = new AbortController(); const signal = swapController.signal;
    main.setAttribute('aria-busy','true');
    main.querySelector('[data-g-navigation-error]')?.remove();
    try {
      const doc = (await loadProductPage(url)).cloneNode(true);
      const next = doc.getElementById('MainContent');
      if (!next?.querySelector('[data-g-product]')) throw new Error('Missing product');
      selectIncomingOffer(next, url, selection);
      if (signal.aborted) return;
      const anchor = main.querySelector('.g-flavour-links');
      const top = anchor?.getBoundingClientRect().top;
      const keepPosition = window.scrollY > 100;
      const previousColours = productColours(main);
      replaceProductSections(main, next);
      document.title = doc.title;
      ['link[rel="canonical"]','meta[name="description"]','meta[property^="og:"]','meta[name^="twitter:"]'].forEach(selector => {
        doc.head.querySelectorAll(selector).forEach(incoming => {
          const key = incoming.getAttribute('property') || incoming.getAttribute('name');
          const existing = key ? [...document.head.querySelectorAll(selector)].find(el => (el.getAttribute('property') || el.getAttribute('name')) === key) : document.head.querySelector(selector);
          if (existing) existing.replaceWith(incoming.cloneNode(true));
        });
      });
      if (!fromHistory) history.pushState({gutcha:true},'',url);
      init();
      renderedProductUrl = location.href; renderedProductState = history.state;
      main.dataset.gSwitchMs = String(Math.round(performance.now() - started));
      animateProductColours(main,previousColours);
      // Allow gallery/sticky layout to settle before correcting the anchor position.
      requestAnimationFrame(() => {
        if (signal.aborted) return;
        if (keepPosition && top !== undefined) {
          const current = main.querySelector('.g-flavour-links');
          if (current) scrollBy({top:current.getBoundingClientRect().top-top,behavior:'instant'});
        }
        if (focus) main.querySelector('.g-flavour-links [aria-current="true"]')?.focus({preventScroll:true});
      });
      let announcement = document.getElementById('g-product-announcement');
      if (!announcement) { announcement=document.createElement('div'); announcement.id='g-product-announcement'; announcement.className='visually-hidden'; announcement.setAttribute('role','status'); document.body.append(announcement); }
      announcement.textContent = main.querySelector('[data-g-product] h1').textContent.trim();
      document.dispatchEvent(new CustomEvent('gutcha:product-change',{detail:{url:url.pathname}}));
      prefetchProductPages();
    } catch (error) {
      if (swapController.signal !== signal || signal.aborted) return;
      if (fromHistory) history.replaceState(renderedProductState,'',renderedProductUrl);
      const notice = document.createElement('p'); notice.dataset.gNavigationError=''; notice.className='g-form-error'; notice.setAttribute('role','alert');
      notice.append('Die Sorte konnte nicht geladen werden. ');
      const retry = document.createElement('a'); retry.href=url.href; retry.textContent='Erneut versuchen'; retry.dataset.gProductLink=''; notice.append(retry);
      main.querySelector('.g-flavour-links').after(notice);
    } finally {
      if (swapController.signal === signal) main.removeAttribute('aria-busy');
    }
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-g-product-link]');
    if (link && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) { if (link.target && link.target !== '_self' || link.hasAttribute('download')) return;
      event.preventDefault();
      if (link.getAttribute('aria-current') === 'true') {
        swapController?.abort();
        document.getElementById('MainContent')?.removeAttribute('aria-busy');
        return;
      }
      swap(link.href, {preserveOffer:Boolean(link.closest('.g-flavour-links')),focus:event.detail === 0}); return; }
    const heroButton = event.target.closest('[data-g-hero-select]');
    if (heroButton) {
      const hero = heroButton.closest('[data-g-hero]'); const index = heroButton.dataset.gHeroSelect;
      hero.querySelectorAll('[data-g-stage]').forEach(stage => { stage.hidden = stage.dataset.gStage !== index; if (!stage.hidden) {hero.querySelector('[data-g-hero-cta]').href = stage.dataset.gUrl;hero.querySelector('[data-g-hero-label]').textContent=stage.dataset.gCta;hero.style.setProperty('--g-hero-flavour',stage.style.getPropertyValue('--g-flavour'));} });
      hero.querySelectorAll('[data-g-hero-select]').forEach(button => button.setAttribute('aria-pressed', String(button === heroButton))); return;
    }
    const gallery = event.target.closest('[data-g-gallery]');
    if (gallery) { const track = gallery.closest('.g-gallery').querySelector('.g-gallery-track'); track.scrollBy({left:Number(gallery.dataset.gGallery) * track.clientWidth,behavior:motion()}); }
    if (event.target.closest('.g-mobile-menu nav a')) event.target.closest('.g-mobile-menu').open = false;
  });
  document.addEventListener('change', event => { if (event.target.matches('[data-g-variant]')) { const url = new URL(location.href); url.searchParams.set('variant', event.target.value); swap(url); } });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (form.matches('.g-change-form')) {
      event.preventDefault(); const button=form.querySelector('button');button.disabled=true;
      const data=new FormData(form);
      try {const res=await fetch(root()+'cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:data.get('id'),quantity:Number(data.get('quantity'))})});const body=await res.json();if(!res.ok)throw new Error(body.description||body.message||errorText());location.assign(root()+'cart');}
      catch(error){message(form,error.message||errorText());button.disabled=false;}
      return;
    }
    if (form.matches('.g-product-form') && form.closest('[data-g-offer-preview]')) {
      event.preventDefault();
      message(form,'Dies ist die Relaunch-Vorschau. Bestellungen sind hier noch nicht freigeschaltet.');
      return;
    }
    if (form.matches('.g-product-form')) {
      event.preventDefault(); const button = form.querySelector('[type="submit"]'); if (button.disabled) return;
      button.disabled = true; form.setAttribute('aria-busy','true'); const data = new FormData(form);
      // Our selector owns selling_plan; prevent Appstle's widget hook from replacing it.
      try { const res = await fetch(root() + 'cart/add.js?appstle=true',{method:'POST',credentials:'same-origin',headers:{Accept:'application/json'},body:data}); const body = await res.json(); if (!res.ok) throw new Error(body.description || body.message || errorText()); location.assign(root()+'cart'); }
      catch(error) { message(form,error.message || errorText()); button.disabled=false; form.removeAttribute('aria-busy'); }
    }
    if (document.documentElement.dataset.gutchaPreview && form.matches('.g-contact-form,.g-newsletter-form')) { event.preventDefault(); message(form,'Lokale Vorschau: Es wurde nichts gesendet. Das echte Formular wird erst in Shopify geprüft.'); }
    if (document.documentElement.dataset.gutchaPreview && event.submitter?.name === 'checkout') { event.preventDefault(); message(form,'Lokale Vorschau: Kein echter Checkout und keine Bestellung.'); }
  });
  let touch;
  document.addEventListener('touchstart', event=> { if(event.target.closest('.g-hero-art')) touch={x:event.touches[0].clientX,y:event.touches[0].clientY,hero:event.target.closest('[data-g-hero]')}; },{passive:true});
  document.addEventListener('touchend',event=>{if(!touch)return;const dx=event.changedTouches[0].clientX-touch.x,dy=event.changedTouches[0].clientY-touch.y;if(Math.abs(dx)>60 && Math.abs(dx)>Math.abs(dy)*1.5){const buttons=[...touch.hero.querySelectorAll('[data-g-hero-select]')];const current=buttons.findIndex(b=>b.getAttribute('aria-pressed')==='true');buttons[(current+(dx<0?1:buttons.length-1))%buttons.length]?.click();}touch=null;},{passive:true});
  addEventListener('popstate', event => {
    if (!document.querySelector('[data-g-product]')) return;
    offerSelection = event.state?.gutchaOffer || null;
    swap(location.href,{fromHistory:true});
  });
  document.addEventListener('shopify:section:unload', event => { flavourCleanups.forEach((cleanup, section) => { if (event.target.contains(section)) { cleanup(); flavourCleanups.delete(section); } }); });
  document.addEventListener('shopify:section:load', () => { productPages.clear(); init(); });
  document.querySelectorAll('#MainContent > [id]').forEach(node => sectionMarkup.set(node.id, node.outerHTML));
  init();
  prefetchProductPages();
  renderedProductUrl = location.href; renderedProductState = history.state;

})();
